<template>
  <svg
    class="icon"
    :class="{'icon--spin':spin}"
    :height="size"
    viewBox="0 0 16 16"
    :width="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      style="stroke:currentColor;"
      stroke-width="2"
      transform="translate(2 2)"
    >
      <path d="m0 3h12" /><path d="m2 2v8c0 3.5 8 3.5 8 0s0-5.5 0-8" />
      <path d="m4 3c0-1-.5-3 2-3s2 2 2 3" />
    </g>
  </svg>
</template>


<script setup>
import { baseIconProps } from '../base/use-base-icon.js';

defineProps(baseIconProps);

</script>

